import {createSinglePathSVG} from './TEMPLATE'

export const Bold_Stroke2_Corner0_Rounded = createSinglePathSVG({
  viewBox: '0 0 20 20',
  strokeWidth: 1.67,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  path: 'M5 10H11.6667C13.5076 10 15 8.50762 15 6.66667C15 4.82572 13.5076 3.33333 11.6667 3.33333H5V10ZM5 10H12.5C14.3409 10 15.8333 11.4924 15.8333 13.3333C15.8333 15.1743 14.3409 16.6667 12.5 16.6667H5V10Z',
})
